import type { ReactNode } from "react";

/** An empty state (`.k-empty`): one bold line, then a calm sentence or the one thing to do. */
export function Empty({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="k-empty">
      <b>{title}</b>
      {children}
    </div>
  );
}
